const removeLoyaltyPrefix = (loyaltyNumber) => {
  if (loyaltyNumber && loyaltyNumber.length === 17) {
    return loyaltyNumber.slice(9);
  }

  return loyaltyNumber;
};

const formatPassengers = (passengers) =>
  passengers.map((passenger) => {
    const { unformattedPhoneNumber, loyaltyNumber, ...rest } = passenger;
    const { countryCode, number } = unformattedPhoneNumber || {};

    return {
      ...rest,
      phoneCountryCode: unformattedPhoneNumber && countryCode?.replace('+', ''),
      phoneNumber: unformattedPhoneNumber && number,
      loyaltyNumber: removeLoyaltyPrefix(loyaltyNumber)
    };
  });

export default formatPassengers;
